var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32ZM8 32C8 45.2548 18.7452 56 32 56C45.2548 56 56 45.2548 56 32C56 18.7452 45.2548 8 32 8C18.7452 8 8 18.7452 8 32Z",
    fill: "#CCD7DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2469 59.0459C39.8187 61.1798 38.5524 63.3998 36.3639 63.7011C32.706 64.2046 28.9782 64.0726 25.3468 63.3007C20.4072 62.2508 15.7863 60.0467 11.8617 56.8687C7.93721 53.6906 4.82054 49.6289 2.76655 45.0156C1.25654 41.624 0.352379 38.0052 0.0843867 34.3225C-0.0759513 32.1192 1.83226 30.419 4.03837 30.5346V30.5346C6.24448 30.6502 7.90465 32.5427 8.15662 34.7374C8.4342 37.1551 9.07879 39.5244 10.0749 41.7617C11.6154 45.2217 13.9529 48.268 16.8963 50.6515C19.8397 53.035 23.3054 54.6881 27.0101 55.4755C29.4057 55.9847 31.8571 56.1226 34.2797 55.8915C36.4789 55.6816 38.6752 56.9121 39.2469 59.0459V59.0459Z",
    fill: "#8BA9B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.3fe468f139d4f998180b40f8a8ff242b.svg";
export { ForwardRef as ReactComponent };